module.exports = __webpack_public_path__ + "img/service_network.3cfa877f.jpg";